import { useTranslation } from '@wix/wix-i18n-config';
import { categoryByKey, CategoryKey } from 'config/categories';
import React, { FC } from 'react';
import { useAppStore } from 'stores/appStore';
import styles from '../SelectCategoryStep.scss';
import { Text, Thumbnail } from '@wix/design-system';
import { productsByCategory } from 'config/products';

export const SelectCategoryStepOptions: FC = () => {
  const { t } = useTranslation();

  const selectedCategory = useAppStore((state) => state.selectedCategory);
  const setSelectedCategory = useAppStore((state) => state.setSelectedCategory);
  const setSelectedProducts = useAppStore((state) => state.setSelectedProducts);

  const handleSelectCategory = (category: CategoryKey) => {
    setSelectedCategory(category);
    const [firstProduct] = productsByCategory[category];
    setSelectedProducts([firstProduct.id]);
  };

  return (
    <div className={styles.selectCategoryStepOptions}>
      {Object.values(CategoryKey).map((key) => {
        const Icon = categoryByKey[key].icon;
        return (
          <Thumbnail onClick={() => handleSelectCategory(key)} selected={selectedCategory === key}>
            <div className={styles.selectCategoryStepOptionsItem}>
              <Text>{t(`select-category-step.options.item.title.${key}`)}</Text>
              <Icon />
            </div>
          </Thumbnail>
        );
      })}
    </div>
  );
};
